import { defineMessages } from "react-intl"

export const equipmentListMessages = defineMessages({
	headerCategory: {
		defaultMessage: "Category",
		id: "printPriceTag.equipmentList.header.category",
	},
	headerCode: {
		defaultMessage: "Code",
		id: "printPriceTag.equipmentList.header.code",
	},
	headerName: {
		defaultMessage: "Name",
		id: "printPriceTag.equipmentList.header.name",
	},
	headerVisible: {
		defaultMessage: "Visible",
		id: "printPriceTag.equipmentList.header.visible",
	},
	noResult: {
		defaultMessage: "0 equipment found",
		id: "printPriceTag.equipmentList.noResult",
	},
})
